<template>
  <v-card :flat="true">
    <v-row v-if="$vuetify.display.mdAndUp">
      <v-col cols="12">
        <v-timeline
            align="start"
            direction="horizontal"
        >
          <v-timeline-item
              v-for="state in stateGuide"
              :key="state.title"
              :icon="state.icon"
              dot-color="grey"
              fill-dot="true"
          >
            <v-card>
              <v-card-title class="text-subtitle-2">
                {{ state.title }}
              </v-card-title>
              <v-card-text class="bg-white text-caption">
                <p>{{ state.description }}</p>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <alert-card
        v-if="alert.visible === true"
        v-model:visible="alert.visible"
        :type="alert.type"
        :title="alert.title"
        :text="alert.text"
        :closable="false"
        class="px-0"
    />
    <car-request-list
        :items="items"
        :skeleton-amount="limit"
        :loading="loading"
    />
    <v-pagination
        v-model="this.page"
        :length="this.pageAmount"
    />
  </v-card>
</template>

<script>
import {auth} from "@/common/auth";
import {router} from "@/router";
import {api} from "@/common/api";
import {inject} from "vue";
import CarRequestList from "@/components/CarRequest/CarRequestList.vue";
import {dates} from "@/common/dates";
import AlertCard from "@/components/AlertCard.vue";
import {messages} from "@/common/enum/messages";
import {CONFIG} from "@/common/config";
import {CarRequestStatus} from "@/common/enum/car_request_status";

export default {
  name: "UserCarRequestsView",
  components: {AlertCard, CarRequestList},
  data() {
    return {
      items: [],
      page: 1,
      limit: 10,
      total: 1,
      loading: false,
      carsRequestState: null,
      alert: {
        visible: false,
        type: 'error',
        title: 'Error',
        text: ''
      },

      stateGuide: [
        {
          'title': 'Request car',
          'description': 'Search and request car you like',
          'icon': 'mdi-cart-check'
        },
        {
          'title': 'Inspection',
          'description': 'We will inspect car and provide you all info about it',
          'icon': 'mdi-car-info'
        },
        {
          'title': 'Buy',
          'description': 'We will inspect car and provide you all info about it',
          'icon': 'mdi-account-cash'
        },
        {
          'title': 'Delivery',
          'description': 'We will deliver car to your country',
          'icon': 'mdi-ferry'
        },
        {
          'title': 'Your selfie with car',
          'description': 'We would be happy to see you with your new car',
          'icon': 'mdi-thumb-up'
        }
      ]
    }
  },
  computed: {
    pageAmount() {
      return Math.ceil(this.total / this.limit)
    }
  },
  watch: {
    page() {
      this.loadCarRequests()
    },
  },
  setup() {
    return {
      switchAuthorizationState: inject('authorization').switchState
    }
  },
  mounted() {
    this.loadCarRequests()
  },
  methods: {
    loadCarRequests() {
      const token = auth.getToken()
      if (token == null) {
        this.switchAuthorizationState()
        router.push({name: 'sign-in', state: {redirectTo: 'home'}})
        return
      }

      if (this.carsRequestState && !this.carsRequestState.signal.aborted) {
        this.carsRequestState.abort()
      }

      this.carsRequestState = new AbortController()
      this.loading = true
      api.getCurrentCarRequests(token, {
        page: this.page,
        limit: this.limit
      }, this.carsRequestState.signal, this.setCarRequests)
    },
    setCarRequests(response) {
      this.loading = false
      if (response?.data?.status === 'error') {
        this.alert.visible = true
        this.alert.type = 'error'
        this.alert.title = 'Error'
        this.alert.text = response.data?.message?.length === 0 ? messages.en.user_orders_view.orders_loading_error : response.data.message
        return
      }

      this.alert.visible = false
      const carRequests = response.data.car_requests
      this.total = response.data.total
      this.items = carRequests.map(carRequest => {
        return {
          id: carRequest.id,
          title: carRequest.car.manufacturer.english_name + ' ' + carRequest.car.model.english_name + ', ' + carRequest.car.year.value,
          createdAt: dates.mapToDateTime(carRequest.created_at),
          mainPhoto: CONFIG.API_HOST + '/api/v1/car-photos/' + carRequest.car.main_photo.id,
          engine: carRequest.car.engine,
          transmission: carRequest.car.transmission.english_name,
          fuel: carRequest.car.fuel_type.english_name,
          millage: carRequest.car.mileage.value,
          vin: carRequest.car.vin,
          description: carRequest.car.description,
          messageIndicator: false,
          status: CarRequestStatus[carRequest.last_status.state],
          prices: carRequest.car.public_prices,
          deliveryPrice: carRequest.last_status.delivery_price.value != 0 ? carRequest.last_status.delivery_price.value : null,
          paperworkPrice: carRequest.last_status.paper_work_price.value != 0 ? carRequest.last_status.paper_work_price.value : null,
        }
      })
    }
  }
}
</script>

<style scoped>

</style>